module.exports = __webpack_public_path__ + "static/media/Colette Stripe King Headboard - 180 cm_Brown.7f4d63d7.png";